<template>
  <div>
    <button class="btn btn-info btn-sm font-weight-bold btn-sm ml-5"
            v-b-modal="`bv-modal-example`">
      <i class="flaticon-upload"></i>
      Import tác vụ band cao
    </button>
    <b-modal id="bv-modal-example" hide-footer centered size="lg" @hidden="resetData()">
      <template #modal-title>
        <p class="mb-0">Import dữ liệu</p>
      </template>
      <div v-if="!displayErrorCheckTable">
        <p>Bước 1: Tải file mẫu csv</p>
        <button type="button" class="btn btn-primary mb-4" @click="downloadExampleFile()">Tải file mẫu cho test speaking
          band 6.5+
        </button>
        <p>Bước 2: Thiết lập dữ liệu tại file googlesheet, tải xuống file định dạng .csv và upload file đó lên hệ
          thống</p>
        <button @click="openPicker()" type="button" class="btn btn-warning" :disabled="nameFile !== ''"><i
            class="flaticon-upload mr-2"></i>Upload file
        </button>
        <input
            ref="picker"
            type="file"
            accept=".csv,text/csv"
            style="display:none"
            @change="onPick"
        />
        <div class="mt-6" style="width: fit-content; position: relative" v-if="nameFile">
          <span style="background-color: #D9D9D9; border-radius: 4px " class="px-2 py-2">{{ nameFile }}</span>
          <i @click="deleteFile()" class="text-danger el-icon-circle-close cursor-pointer ml-4"
             style="position: absolute;right: -8px; top:-15px"></i>
        </div>
      </div>
      <div v-else class="preview-section">
        <PreviewTable
            :data="dataJson"
            :rules="HighBandTaskSchema"
            :labels="labels"
            @validated="handleValidated"
            :external-errors="extendError"
        />
      </div>
      <div class="mt-6 d-flex justify-content-end">
        <button type="button" class="btn btn-secondary mr-4" :disabled="loading" @click="closeModal()">Hủy</button>
        <button v-if="isValid === null" type="button" class="btn btn-primary" @click="checkError()" :disabled="loading || nameFile === ''" ><i class="el-icon-loading" v-if="loading"></i>Tiếp theo</button>
        <button v-else-if="isValid === true" type="button" class="btn btn-primary" @click="importDataBand()" :disabled="loading"><i class="el-icon-loading" v-if="loading"></i>Import</button>
        <button v-else type="button" class="btn btn-danger" @click="backImportDisplay()">Quay lại</button>
      </div>
    </b-modal>
  </div>

</template>

<script>

import PreviewTable from "@/components/PreviewTable.vue";
import {HighBandTaskSchema} from "@/core/schemas/highBandTask.validation.schema";
import {CHECK_VALIDATE_IMPORT_HIGH_BAND, IMPORT_HIGH_BAND} from "@/core/services/store/test/testInput.module";

export default {
  name: "TaskImportHighBand",
  computed: {
    HighBandTaskSchema() {
      return HighBandTaskSchema
    }
  },
  components: {
    PreviewTable
  },
  data() {
    return {
      dataJson: [],
      nameFile: "",
      displayErrorCheckTable: false,
      ErrorCheckTableData: [],
      labels: {
        hinh_thuc_test: 'Hình thức test',
        ten_doi_tuong_xu_ly: 'Tên đối tượng xử lý',
        sdt_doi_tuong_xu_ly: 'SĐT đối tượng xử lý',
        ma_nhan_su_nguoi_phu_trach: 'Mã nhân sự phụ trách',
        trung_tam: 'Trung tâm',
        co_so: 'Cơ sở',
        ma_nguoi_dat_lich: 'Mã người đặt lịch',
        ngay_lam: 'Ngày làm',
        thoi_gian_bat_dau: 'Thời gian bắt đầu',
        thoi_gian_ket_thuc: 'Thời gian kết thúc',
        diem_speaking: 'Điểm Speaking',
        diem_tieu_chi_1_speaking_do_troi_chay_va_mach_lac: 'Điểm TC1 Speaking (Độ trôi chảy & mạch lạc)',
        nhan_xet_cu_the_tieu_chi_1_speaking_do_troi_chay_va_mach_lac: 'Nhận xét TC1 Speaking',
        diem_tieu_chi_2_speaking_von_tu: 'Điểm TC2 Speaking (Vốn từ)',
        nhan_xet_cu_the_tieu_chi_2_speaking_von_tu: 'Nhận xét TC2 Speaking',
        diem_tieu_chi_3_speaking_do_da_dang_va_chinh_xac_cua_ngu_phap: 'Điểm TC3 Speaking (Ngữ pháp)',
        nhan_xet_cu_the_tieu_chi_3_speaking_do_da_dang_va_chinh_xac_cua_ngu_phap: 'Nhận xét TC3 Speaking',
        diem_tieu_chi_4_speaking_phat_am: 'Điểm TC4 Speaking (Phát âm)',
        nhan_xet_cu_the_tieu_chi_4_speaking_phat_am: 'Nhận xét TC4 Speaking',
        diem_writing: 'Điểm Writing',
        diem_tieu_chi_1_writing_dap_ung_yeu_cau_de_bai: 'Điểm TC1 Writing (Đáp ứng đề bài)',
        nhan_xet_cu_the_tieu_chi_1_writing_dap_ung_yeu_cau_de_bai: 'Nhận xét TC1 Writing',
        diem_tieu_chi_2_writing_do_mach_lac: 'Điểm TC2 Writing (Mạch lạc)',
        nhan_xet_tieu_chi_2_writing: 'Nhận xét TC2 Writing',
        diem_tieu_chi_3_writing_tu_vung: 'Điểm TC3 Writing (Từ vựng)',
        nhan_xet_tieu_chi_3_writing: 'Nhận xét TC3 Writing',
        diem_tieu_chi_4_writing_ngu_phap: 'Điểm TC4 Writing (Ngữ pháp)',
        nhan_xet_tieu_chi_4_writing: 'Nhận xét TC4 Writing',
        bai_viet_co_dau_hieu_dao_van_khong: 'Bài viết có dấu hiệu đạo văn không?',
        ti_le_dao_van_cua_bai_viet: 'Tỉ lệ đạo văn',
        nhan_xet_cu_the_dan_chung: 'Nhận xét dẫn chứng',
        so_cau_dung_listening: 'Số câu đúng Listening',
        diem_listening: 'Điểm Listening',
        so_cau_dung_reading: 'Số câu đúng Reading',
        diem_reading: 'Điểm Reading',
        overall: 'Overall',
        khoa_hoc_goi_y: 'Khóa học gợi ý'
      },
      isValid: null,
      validationErrors: [],
      extendError: [],
      loading:false
    }
  },
  methods: {
    async importDataBand(){
      try {
        this.loading = true
        const res = await this.$store.dispatch(IMPORT_HIGH_BAND,this.dataJson)
        this.$message({
          showClose: true,
          message: 'Import thành công',
          type: 'success'
        });
        this.$bvModal.hide('bv-modal-example')
        this.$emit('createSuccess')
      }catch (e){
        this.$message({
          showClose: true,
          message: `${e?.response.data?.message}`,
          type: 'error'
        });
      }finally {
        this.loading = false
      }

    },
    downloadExampleFile() {
      const link = document.createElement('a');
      link.href = '/excel/File mẫu import tác vụ gia sư band 6.5+.csv';
      link.download = 'File mẫu import tác vụ gia sư band 6.5+.csv';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    openPicker() {
      this.$refs.picker && this.$refs.picker.click();
    },
    async onPick(event) {
      if (event.target.files[0].type !== 'text/csv') {
        this.$notify({
          title: 'Sai định dạng',
          message: 'File import phải là file csv',
          type: 'warning'
        });
        event.target.value = ''
        return
      }

      if (!event.target.files.length) {
        event.target.files = null
        return
      }
      let dataImport = event.target.files[0];

      try {
        this.dataJson = await this.fileToJson(dataImport)
        this.dataJson.forEach((data) => {
          Object.keys(data).forEach((key) => {
            data[this.convertKey(key)] = data[key]
            delete data[key];
          })
        })
        this.nameFile = event.target.files[0].name
      } catch (error) {
        console.error('Error processing file:', error);
        this.$notify({
          title: 'Lỗi',
          message: 'Có lỗi xảy ra khi đọc file: ' + error.message,
          type: 'error'
        });
      } finally {
        event.target.value = ''
      }
    },
    removeVietnameseTones(str) {
      str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
      str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
      str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
      str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
      str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
      str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
      str = str.replace(/đ/g, "d");
      str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
      str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
      str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
      str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
      str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
      str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
      str = str.replace(/Đ/g, "D");
      str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
      str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
      // Remove extra spaces
      str = str.replace(/ + /g, " ");
      str = str.trim();
      // Remove punctuations
      str = str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, " ");
      return str;
    },
    convertKey(key) {
      let myString = this.removeVietnameseTones(key);
      let trimmedString = myString.trim();
      let formattedString = trimmedString.replace(/\s+/g, '_');
      return formattedString.toLowerCase()
    },
    async fileToJson(file) {
      return new Promise((res, rej) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          try {
            const rawText = (e.target.result || '').toString();
            // Bỏ BOM nếu có
            const csvText = rawText.replace(/^\uFEFF/, '');

            // Parse toàn bộ text (KHÔNG split theo \n trước)
            const rows = this.parseCSV(csvText);
            if (!rows.length) {
              rej(new Error('File CSV rỗng'));
              return;
            }

            // Hàng 1 là header
            const headers = rows[0].map(h => (h || '').replace(/^\uFEFF/, '').trim());

            // Các hàng sau là dữ liệu
            const processed = rows.slice(1)
                .filter(r => r.some(cell => (cell || '').trim() !== '')) // bỏ dòng trống thật sự
                .map(row => {
                  const obj = {};
                  headers.forEach((h, i) => {
                    obj[h] = (row[i] ?? '').toString();
                  });
                  return obj;
                });

            res(processed);
          } catch (err) {
            rej(err);
          }
        };
        reader.onerror = (e) => rej(e);
        reader.readAsText(file, 'utf-8');
      });
    },
    parseCSV(text) {
      const rows = [];
      let row = [];
      let field = '';

      let inQuotes = false;
      const len = text.length;

      for (let i = 0; i < len; i++) {
        const c = text[i];

        if (c === '"') {
          if (inQuotes) {
            // Nếu đang trong quotes và gặp "" -> nghĩa là ký tự " literal
            if (i + 1 < len && text[i + 1] === '"') {
              field += '"';
              i++; // bỏ qua ký tự " tiếp theo
            } else {
              // đóng quotes
              inQuotes = false;
            }
          } else {
            // mở quotes (chỉ mở nếu field hiện tại chưa có gì hoặc vừa gặp delimiter)
            inQuotes = true;
          }
          continue;
        }

        if (!inQuotes) {
          if (c === ',') {
            // kết thúc 1 field
            row.push(field);
            field = '';
            continue;
          }

          if (c === '\n' || c === '\r') {
            // kết thúc 1 row
            row.push(field);
            field = '';
            // xử lý CRLF: nếu là \r\n thì nhảy qua \n
            if (c === '\r' && i + 1 < len && text[i + 1] === '\n') i++;
            rows.push(row);
            row = [];
            continue;
          }
        }

        // ký tự bình thường
        field += c;
      }

      // đẩy nốt field/row cuối nếu còn
      row.push(field);
      // nếu dòng cuối không hoàn toàn trống thì thêm vào
      if (row.length > 1 || (row.length === 1 && row[0] !== '')) {
        rows.push(row);
      }
      return rows;
    },
    deleteFile() {
      this.nameFile = "";
      this.dataJson = []
    },
    closeModal() {
      this.$bvModal.hide('bv-modal-example')
    },
    validateTimeStartAndTimeEnd(){
      let error = []
      this.dataJson.forEach((data,index)=>{
        if(!data.thoi_gian_ket_thuc || !data.thoi_gian_bat_dau) return;
        if(data.thoi_gian_bat_dau > data.thoi_gian_ket_thuc){
        error.push({row: index + 1, field:'thoi_gian_bat_dau',message:'Thời gian bắt đầu không được lớn hơn thời gian kết thúc'})
        }
        if (data?.bai_viet_co_dau_hieu_dao_van_khong === "Không" && +data.ti_le_dao_van_cua_bai_viet !== 0){
          error.push({row: index + 1, field:'ti_le_dao_van_cua_bai_viet',message:'Nếu chọn \'Không\' thì tỉ lệ đạo văn bắt buộc phải bằng 0'})
        }
        if (data?.bai_viet_co_dau_hieu_dao_van_khong === "Có" && +data.ti_le_dao_van_cua_bai_viet === 0){
          error.push({row: index + 1, field:'ti_le_dao_van_cua_bai_viet',message:'Nếu chọn \'Có\' thì tỉ lệ đạo văn bắt không được bằng 0'})
        }
      })
      return error
    },
    async checkError() {
      try {
        this.loading = true
        let res =  await this.$store.dispatch(CHECK_VALIDATE_IMPORT_HIGH_BAND,this.dataJson)
        this.extendError = res?.data?.errors ?? []
        const timeError = this.validateTimeStartAndTimeEnd()??[]
        this.extendError = this.extendError.concat(timeError)
        this.displayErrorCheckTable = true;
      }catch (e) {
        this.extendError = this.validateTimeStartAndTimeEnd()??[]
        this.displayErrorCheckTable = true;
      }finally {

        this.loading = false      }

    },
    backImportDisplay(){
      this.displayErrorCheckTable = false;
      this.isValid = null
    },
    handleValidated({errors, isValid}) {
      this.validationErrors = errors || []
      this.isValid = isValid;
    },
    resetData() {
      this.dataJson = [];
      this.nameFile = "";
      this.displayErrorCheckTable = false;
      this.ErrorCheckTableData = [];
      this.isValid = null;
      this.validationErrors = []
    }
  }

}
</script>

<style scoped>
.el-icon-circle-close:hover {
  font-size: 22px;
  font-weight: bold;
}
</style>